export const VERIFICATION_STAGES_WITH_NOTIFICATION = [2];
export const VERIFICATION_PERSONAL_DETAILS_NOTIFICATION = ['identification'];
export const VERIFICATION_PROFESSIONAL_DETAILS_NOTIFICATION = [
    'specialty',
    'location',
    'medical-school',
    'profession',
];
